import { CommentModel } from '@barthauer/abc/common-editors';
import { MtDocument, MtObject, Reminder } from './mtData.model';

export class MtTicket {
  Id: string;
  ObjectType: number;
  Nummer: string;
  Object: MtObject;
  TicketTasks: MtTicketTask[];
  Dringlichkeit: string;
  DringlichkeitDisplayText: string;
  Status: string;
  Bezeichnung: string;
  HasGeometry: boolean = false;
  AllowDeletion: boolean = false;

  constructor(data: any) {
    Object.assign(this, data);
    this.TicketTasks = new Array<MtTicketTask>();

    if (Array.isArray(data.Objects)) {
      this.Object = new MtObject(data.Objects[0]);
    }

    if (Array.isArray(data.TicketTasks)) {
      for (const result of data.TicketTasks) {
        this.TicketTasks.push(new MtTicketTask(result));
      }
    }
  }
}

export class MtTicketTask {
  Id: string;
  ObjectType: number;
  Bezeichnung: string;
  LfdNr: number;
  Status: string;
  StatusDisplayText: string;
  StartDatum: string;
  StartZeit: string;
  EndDatum: string;
  EndZeit: string;
  IdRefMtResource: string;
  Reminders: Reminder[];
  Documents: MtDocument[];
  Comments: CommentModel[];

  constructor(data: any) {
    Object.assign(this, data);
    this.Reminders = new Array<Reminder>();
    if (Array.isArray(data.Reminders)) {
      for (const rem of data.Reminders) {
        this.Reminders.push(new Reminder(rem));
      }
    }
    this.Documents = new Array<MtDocument>();
    if (Array.isArray(data.Documents)) {
      for (const doc of data.Documents) {
        this.Documents.push(new MtDocument(doc));
      }
    }
    this.Comments = new Array<CommentModel>();
    if (Array.isArray(data.Comments)) {
      for (const c of data.Comments) {
        this.Comments.push(new CommentModel(c));
      }
    }
  }
}

export class MtTicketCounterHelper {
  CountTicketsAll: number;
  CountTicketsFinished: number;
  CountTicketsEditing: number;
  CountTicketsNotStarted: number;
  HasTicketTaskReminders: boolean;

  get CountTicketsOpen(): number {
    return this.CountTicketsAll - this.CountTicketsFinished - this.CountTicketsEditing;
  }

  constructor(data: any) {
    Object.assign(this, data);
  }
}
